import { useCallback } from 'react';
import { useDialog } from '@/context/DialogContext';
import type { PreviewableFile } from '@/components/FilePreviewDialog';

/**
 * Opens a supporting document in the in-app preview (`FilePreviewDialog`,
 * Download in the header), on top of the request details. The preview (and
 * its PDF viewer) loads on the first click only, so the leave decision
 * pieces that render this list stay light wherever they are imported.
 */
export function usePreviewLeaveAttachment() {
  const { openDialog } = useDialog();
  return useCallback(
    async (file: PreviewableFile) => {
      const { FilePreviewDialog, FilePreviewHeaderActions } =
        await import('@/components/FilePreviewDialog');
      openDialog({
        title: file.title || file.fileName,
        containerClass: 'w-full md:w-5xl md:max-w-none',
        headerActionContent: <FilePreviewHeaderActions file={file} />,
        content: <FilePreviewDialog file={file} />,
      });
    },
    [openDialog]
  );
}
